import type { ReactNode } from "react";

import { Header } from "./Header";

interface NewIntakeLayoutProps {
  children: ReactNode;
}

export const PatientCasesLayout = ({ children }: NewIntakeLayoutProps) => {
  return (
    <div className="flex h-screen flex-col gap-y-4 overflow-hidden bg-background">
      <Header />
      <main className="h-full grow overflow-y-auto px-16">{children}</main>
    </div>
  );
};
